import * as o from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/DownloadSimple.es.js";
const e = o.forwardRef((a, m) => /* @__PURE__ */ o.createElement(r, { ref: m, ...a, weights: t }));
e.displayName = "DownloadSimpleIcon";
const l = e;
export {
  l as DownloadSimple,
  e as DownloadSimpleIcon
};
